import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import MobileProfile from '@nykaa/auth/components/ProfileSection/MobileInfo';
import { TOAST_TIMER, AUTH_EVENTS } from '@nykaa/auth-shared/constants';
import Toast, { VARIANT } from '@nykaa/ui-components/Toast';
import useAuthData from '@nykaa/auth-shared/hooks/useAuthData';
import { pushEvent } from '@nykaa/data-layer';
import { getLogin } from 'layouts/Auth/components/Welcome/helpers';
import { State } from 'store/types';

const MobileInfo = (showNudge: boolean) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [isError, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const {
    error,
    message,
    isApiError,
    name: fullName,
    mobile,
    sendOtpToMail,
  } = useAuthData();
  const isCheckExistenceCaptchaEnabled = useSelector(
    (state: State) =>
      state.remoteConfig.configs.configFlags.checkExistenceCaptcha
  );

  const handleCheckExistence = useCallback(
    (name, emailPhone) => {
      pushEvent(AUTH_EVENTS.REGISTRATION_GET_OTP);
      getLogin({
        emailPhone,
        history,
        dispatch,
        setErrorMessage,
        setError,
        name,
        sendOtpToMail,
        isCheckExistenceCaptchaEnabled,
      });
    },
    [dispatch, history, sendOtpToMail, isCheckExistenceCaptchaEnabled]
  );

  return (
    <>
      <MobileProfile
        handleLogin={handleCheckExistence}
        errorText={error ? message : ''}
        initialValues={{
          name: fullName,
          mobile,
        }}
        isNudge={showNudge}
      />
      {(isError || isApiError) && (
        <Toast
          timer={TOAST_TIMER}
          variant={VARIANT.single}
          message={errorMessage || message}
        />
      )}
    </>
  );
};

export default MobileInfo;
